<template>
  <div>
    <!-- 左上标题头 -->
    <!-- 组件05cd9ca0-3dec-11ec-a2e6-953464dcce14开始-->
    <div
      id="item05cd9ca0-3dec-11ec-a2e6-953464dcce14"
      :style="{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '18px',
        lineHeight: '1.5',
        color: '#ffffff',
        textAlign: 'center',
        textShadow: false ? '0px 0px 14px rgba(15, 146, 255,1)' : '',
      }"
      class="centertitle"
    >
      <p>岗位占比</p>
    </div>
    <!-- 组件05cd9ca0-3dec-11ec-a2e6-953464dcce14结束-->
    <!-- 左上echart图展示区域 -->
    <!-- 组件8d374050-3e10-11ec-b331-d9ec61910d4a开始-->
    <div id="item8d374050-3e10-11ec-b331-d9ec61910d4a"></div>
    <!-- 组件8d374050-3e10-11ec-b331-d9ec61910d4a结束-->
    <!-- 左上容器背景图 -->
    <!-- 组件da42a880-eaf0-4a65-b71f-a313e2bd4daf开始-->
    <!-- 最大外框背景图 -->
    <div id="itemda42a880-eaf0-4a65-b71f-a313e2bd4daf">
      <img src="../../../assets/images/线框.png" alt="" :style="{ width: '100%', height: '100%' }" />
    </div>
    <!-- 组件da42a880-eaf0-4a65-b71f-a313e2bd4daf结束-->
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {baseURL} from '@/api/base.js';
import axios from 'axios'
export default {
  mounted () {
    this.getEcharts()
  },
  data () {
    return {
      // 模拟数据
      resData: []
    }
  },
  methods: {
    async getEcharts(){
      await axios.post(baseURL+'/api/getchartyl', {})
    .then(res => {
      this.resData=res.data.statistic
      this.setEcharts()
    })
  .catch(err => {
    console.error('提交失败:', err);
  });
    },
    setEcharts () {
  const showPieData = []
  const rawData = JSON.parse(JSON.stringify(this.resData));

  Object.keys(rawData).forEach(key => {
    if (key !== '__ob__') {
      showPieData.push({
        name: key,
        value: rawData[key][0], // 核心数值用人数
        percentage: rawData[key][1] // 附加百分比
      });
    }
  });

  const chartDom = document.getElementById('item8d374050-3e10-11ec-b331-d9ec61910d4a');
  const myChart = echarts.init(chartDom);

  const option = {
    tooltip: {
      trigger: 'item',
      formatter: (params) => {
        console.log(params.data)
        return `${params.name}: ${params.data.value}人 (${params.data.percentage}%)`;
      }
    },
    series: [{
      type: 'pie',
      radius: [50, 80],
      label: {
        formatter: (params) => {
        return `${params.name}:${params.data.percentage}%`;
      },
        fontSize: 16,
        color: '#fff'
      },
      data: showPieData
    }]
  };

  myChart.setOption(option);
}
  }
}
</script>

<style scoped>
/* 左上背景图位置及大小 */
#itemda42a880-eaf0-4a65-b71f-a313e2bd4daf {
  left: 20px;
  width: 530px;
  height: 300px;
}
/* 标题位置 */
#item05cd9ca0-3dec-11ec-a2e6-953464dcce14 {
  top: 14px;
}
/* echarts图的位置及大小 */
#item8d374050-3e10-11ec-b331-d9ec61910d4a {
  height: 270px;
}
</style>
